import { RefreshCcw } from "lucide-react";
import CircleSpinnerLoader from "@/app/components/ui/Reusable/LoaderComponent/CircleSpinnerLoader";

interface AdvancePaymentCardProps {
  bookingCreated: boolean;
  bookingUpdated: boolean;
  selectedSlotDetails: any;
  prepaidPayment: any;
  isPaymentDisplayPaid: boolean;
  paymentDisplayStatus: string;
  customerDetails: any;
  refreshLoader: boolean;
  logPreviewEvent: (event_type: string, extra?: any) => void;
  setOpen: (open: boolean) => void;
  handelRefesh: () => void;
}

const AdvancePaymentCard = ({
  bookingCreated,
  bookingUpdated,
  selectedSlotDetails,
  prepaidPayment,
  isPaymentDisplayPaid,
  paymentDisplayStatus,
  customerDetails,
  refreshLoader,
  logPreviewEvent,
  setOpen,
  handelRefesh,
}: AdvancePaymentCardProps) => {
  const shouldRender =
    (bookingCreated || bookingUpdated) &&
    (selectedSlotDetails?.prepaid_booking_slot?.toLowerCase() === "yes" || Boolean(prepaidPayment));

  if (!shouldRender) return null;

  return (
    <section className="rounded-[10px] border border-[#808DA033] bg-[#FFFFFF] py-[8px] px-[12px] shadow-[0_2px_10px_rgba(17,24,39,0.05)]">
      <h3 className="text-[14px] font-semibold text-[#000000]">Advance Payment Details</h3>

      <div className="mt-2 grid grid-cols-1 gap-4 md:grid-cols-3">
        <div>
          <p className="text-[14px] font-medium text-[#6D6D6D]">Advance Payment</p>
          <p className="mt-2 text-[14px] font-semibold text-[#222222]">
            ₹{Number(prepaidPayment?.amount ?? selectedSlotDetails?.booking_fee ?? 0)}
          </p>
        </div>

        <div>
          <p className="text-[14px] font-medium text-[#6D6D6D]">Payment Status</p>
          <p
            className={`mt-2 text-[14px] font-semibold capitalize ${isPaymentDisplayPaid
              ? "text-[#11885B]"
              : "text-[#FFB814]"
              }`}
          >
            •{" "}
            {paymentDisplayStatus || "Pending"}
          </p>
        </div>

        <div>
          <p className="text-[14px] font-medium text-[#6D6D6D]">Payment Number</p>
          <p className="mt-2 text-[14px] font-semibold text-[#222222]">+91 {customerDetails?.mobile || "NA"}</p>
        </div>
      </div>

      <div className="mt-4 flex flex-col gap-3 md:flex-row md:items-center">
        {isPaymentDisplayPaid ? null : (
          <button
            className="rounded-[8px] bg-[#00873C] p-[8px] text-[14px] font-semibold text-white"
            onClick={() => {
              logPreviewEvent("RESEND_WHATSAPP_CLICK", {
                cta_text: "Resend WhatsApp / Send to Another Number",
                phone: customerDetails?.mobile,
              });
              setOpen(true);
            }}
          >
            Resend WhatsApp / Send to Another Number
          </button>
        )}
        {isPaymentDisplayPaid ? null : (
          <button
            className="inline-flex items-center justify-center gap-2 rounded-[8px] border border-black py-[8px] px-[16px] text-[14px] font-semibold text-black"
            onClick={() => {
              logPreviewEvent("REFRESH_BOOKING_STATUS_CLICK");
              handelRefesh();
            }}
          >
            {refreshLoader ? (
              <CircleSpinnerLoader h="20" w="20" />
            ) : (
              <>
                <RefreshCcw className="h-4 w-4" />
                Refresh
              </>
            )}
          </button>
        )}
      </div>
    </section>
  );
};

export default AdvancePaymentCard;
